/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Andor application API
 * OpenAPI spec version: v1
 */
import { InjectionToken, inject, type Provider } from '@angular/core';

/**
 * Embedded fallback base URL for the `andor` API, resolved at generation
 * time from the OpenAPI specification's `servers` field (`''` when the
 * specification has no servers).
 */
export const ANDOR_SERVER_URL: string = "/";

/**
 * Strips trailing slashes from a base URL.
 *
 * Generated routes always start with `/`, so normalizing here at the token
 * boundary guarantees `${baseUrl}${route}` can never double or drop the
 * separator between them, for either `HttpClient` services or `httpResource`
 * functions.
 */
export function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.replace(/\/+$/, '');
}

/** Context passed to a `AndorBaseUrlResolver` when it is invoked. */
export interface AndorBaseUrlResolverContext {
  /** The explicit `apiId` configured via `override.angular.baseUrl`. */
  readonly apiId: "andor";
  /** The embedded fallback server URL (`ANDOR_SERVER_URL`). */
  readonly serverUrl: string;
}

/** Resolves the runtime base URL for the `andor` API. */
export type AndorBaseUrlResolver = (context: AndorBaseUrlResolverContext) => string;

/**
 * Injectable hook for resolving the `andor` API's base URL at runtime
 * (e.g. from a gateway route registry). Overridden via
 * `provideAndorBaseUrlResolver`; defaults to the embedded specification
 * server URL.
 */
export const ANDOR_BASE_URL_RESOLVER = new InjectionToken<AndorBaseUrlResolver>(
  "ANDOR_BASE_URL_RESOLVER",
  {
    providedIn: 'root',
    factory: (): AndorBaseUrlResolver => (context) => context.serverUrl,
  },
);

/**
 * Runtime base URL for the `andor` API, composed via Angular DI.
 *
 * Precedence: a directly provided value (`provideAndorBaseUrl`) wins
 * outright; otherwise the `ANDOR_BASE_URL_RESOLVER` resolver (default or
 * provided via `provideAndorBaseUrlResolver`) is invoked with the embedded
 * `ANDOR_SERVER_URL` fallback. The result is always normalized.
 */
export const ANDOR_BASE_URL = new InjectionToken<string>("ANDOR_BASE_URL", {
  providedIn: 'root',
  factory: (): string => {
    const resolver = inject(ANDOR_BASE_URL_RESOLVER);
    return normalizeBaseUrl(
      resolver({ apiId: "andor", serverUrl: ANDOR_SERVER_URL }),
    );
  },
});

/** Directly provides the `andor` API's base URL, bypassing the resolver. */
export function provideAndorBaseUrl(baseUrl: string): Provider {
  return { provide: ANDOR_BASE_URL, useValue: normalizeBaseUrl(baseUrl) };
}

/** Provides a custom resolver for the `andor` API's base URL. */
export function provideAndorBaseUrlResolver(
  resolver: AndorBaseUrlResolver,
): Provider {
  return { provide: ANDOR_BASE_URL_RESOLVER, useValue: resolver };
}
